import React from 'react';
import { Pencil, Trash2, Bot, Unlink } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { WorkflowWithAgent } from '../hooks/useWorkflows';

interface WorkflowCardProps {
  workflow: WorkflowWithAgent;
  onDelete: (id: string) => void;
}

export const WorkflowCard: React.FC<WorkflowCardProps> = ({ workflow, onDelete }) => {
  const navigate = useNavigate();

  const handleEdit = () => {
    navigate(`/workflows/${workflow.id}`);
  };

  const isAssigned = !!workflow.assigned_agent_name;
  const nodeCount = workflow.flow_data?.nodes?.length || 0;

  return (
    <div className="bg-white rounded-2xl p-5 shadow-sm hover:shadow-md transition-all border border-grey-200 flex flex-col">
      {/* Header */}
      <div className="flex items-start justify-between mb-3">
        <h3 className="text-foreground font-montserrat text-base font-semibold leading-tight flex-1 mr-2">
          {workflow.nombre}
        </h3>
        <span className="text-xs text-grey-400 font-mono flex-shrink-0">
          {nodeCount} nodos
        </span>
      </div>

      {workflow.descripcion && (
        <p className="text-grey-500 text-sm mb-3 line-clamp-2">{workflow.descripcion}</p>
      )}

      {/* Agent assignment badge */}
      <div className="mb-4">
        {isAssigned ? (
          <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium bg-blue-50 text-blue-700 border border-blue-200">
            <Bot className="w-3.5 h-3.5" />
            {workflow.assigned_agent_name}
          </span>
        ) : (
          <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium bg-grey-100 text-grey-500 border border-grey-200">
            <Unlink className="w-3.5 h-3.5" />
            Sin agente
          </span>
        )}
      </div>

      {/* Actions */}
      <div className="flex gap-2 mt-auto">
        <button
          onClick={handleEdit}
          className="flex-1 h-9 bg-foreground hover:bg-foreground/90 text-white font-montserrat text-sm font-medium rounded-full transition-colors flex items-center justify-center gap-2"
        >
          <Pencil className="w-3.5 h-3.5" />
          Editar Flow
        </button>
        <button
          onClick={() => onDelete(workflow.id)}
          className="h-9 w-9 bg-red-50 hover:bg-red-100 text-red-500 rounded-full transition-colors flex items-center justify-center border border-red-200"
          title="Eliminar flow"
        >
          <Trash2 className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
};
